import { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { computeSynopsis } from "@/lib/calc";
import { compact } from "@/lib/format";

export const ClientSidebar = ({ clients, activeId }) => {
  const [q, setQ] = useState("");
  const list = clients.filter((c) => c.name.toLowerCase().includes(q.toLowerCase()));
  return (
    <nav className="client-sidebar" data-testid="client-sidebar">
      <div className="relative">
        <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
        <Input data-testid="sidebar-search-input" placeholder="Search clients" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 bg-white" />
      </div>
      <div className="mt-3 space-y-1 overflow-y-auto">
        {list.map((c) => {
          const s = computeSynopsis(c.data);
          return (
            <Link key={c.id} to={`/clients/${c.id}`} data-testid={`sidebar-client-${c.id}`} className={`sidebar-item ${c.id === activeId ? "is-active" : ""}`}>
              <span className="font-medium text-sm truncate">{c.name}</span>
              <span className={`font-mono text-[11px] ${s.ins.client.lifeAdditional > 0 ? "text-rose-600" : "text-emerald-600"}`}>
                {s.ins.client.lifeAdditional > 0 ? `Life ins. ${compact(s.ins.client.lifeAdditional, s.d.profile.currency)}` : "Life cover adequate"}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
